<template>

  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
      <p class="mt-3">Veuillez patienter...</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TokenVerifier',

  data() {
    return {
      token: null,
      redirectUrl: '/operations/mes-courses'
    }
  },

  created() {
    this.token = this.$route.query.token
    this.redirectUrl = this.$route.query.redirect || '/operations/mes-courses'

    if (this.token) {
     this.verifierToken()
    } 
  },

  methods: {
    async verifierToken() {
      try {
        const response = await axios.post('/api/check-token', {
          token: this.token
        })

        if (response.data.success == true) {
            const userData = {'token': this.token, 'user': response.data.data}
          // Stocker les infos utilisateur dans localStorage
          localStorage.setItem('espace_yamslogistics_session', JSON.stringify(userData))

          // Redirection vers la page voulue
          this.$router.push(this.redirectUrl)
        } 
        else {
          this.$toast.add({
            severity: 'warn',
            detail: response.data.message,
            life: 5000
          })
        }
      } catch (error) {
        console.error('Erreur de vérification du token :', error)
        this.$router.push('/erreur')
      }
    }
  }
}
</script>

<style scoped>
.vh-100 {
  height: 100vh;
}
</style>
